import { render } from "./PopupDatMatKhau.vue?vue&type=template&id=71e02c2e"
import script from "./PopupDatMatKhau.vue?vue&type=script&lang=js"
export * from "./PopupDatMatKhau.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__